import * as R from 'ramda';
import Select from 'react-select';
import {
  useRef,
  useMemo,
  useState,
  useEffect,
} from 'react';
// mui
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';
// constants
import { FIELD_LABEL, FIELD_VALUE } from '../../../constants';
// components
import { withScrollToViewOnOpen } from './field-list/hocs';
// component report-format-panel
import { getDefaultStyles } from '../../report-format-panel/ui';
import { setOptionLabelFromNameOrValue } from '../../report-format-panel/helpers';
//////////////////////////////////////////////////

const OutsideClickHandler = props => {
  const {
    children,
    menuIsOpen,
    setMenuIsOpen,
  } = props;

  const wrapperRef = useRef(null);

  const handleClick = () => {
    setMenuIsOpen(R.not(menuIsOpen));
  };

  const handleClickOutside = event => {
    const { target } = event;

    const { current } = wrapperRef;

    if (R.and(current, R.not(current.contains(target)))) {
      setMenuIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [setMenuIsOpen]); // eslint-disable-line

  return <Box width={232} ref={wrapperRef} onClick={handleClick}>{children}</Box>;
};

const FieldSelect = withScrollToViewOnOpen(props => {
  const {
    id,
    name,
    value,
    action,
    groupId,
    options,
    dataType,
    fieldIndex,
  } = props;

  const theme = useTheme();

  const { colors, palette } = theme;

  const {
    input,
    option,
    control,
    menuList,
    container,
    singleValue,
    valueContainer,
    DropdownIndicator,
    indicatorSeparator,
  } = getDefaultStyles();

  const [menuIsOpen, setMenuIsOpen] = useState();

  const styles = useMemo(() => ({
    container: provided => ({
      ...provided,
      ...container,
      fontSize: 13,
      display: 'flex',
      margin: '0 5px',
      alignSelf: 'center',
      pointerEvents: null,
      justifyContent: 'center',
    }),

    control: provided => ({
      ...provided,
      ...control,
      minHeight: 30,
      maxHeight: 30,
      width: '100%',
      background: palette.background.default,
      border: `1px solid ${theme.colors.middleGrey}`,
      boxShadow: `0 0 5px 0 ${theme.colors.middleGrey}`,
    }),

    singleValue: provided => ({
      ...provided,
      ...singleValue,
    }),

    indicatorSeparator: provided => ({
      ...provided,
      ...indicatorSeparator,
    }),

    indicatorsContainer: provided => ({
      ...provided,
      height: 30,
      paddingRight: '10px',
    }),

    option: (provided, state) => ({
      ...provided,
      ...option(provided, state),
      minHeight: 30,
      maxWidth: '232px',
      whiteSpace: 'break-spaces',
      wordBreak: 'break-word !important',
    }),

    input: provided => ({
      ...provided,
      ...input,
      maxWidth: '20px',
    }),

    menuList: base => ({
      ...base,
      ...menuList,
      maxHeight: 315,
    }),

    valueContainer: provided => ({
      ...provided,
      ...valueContainer,
    }),
  }), [colors]) // eslint-disable-line

  return (
    <OutsideClickHandler setMenuIsOpen={setMenuIsOpen} menuIsOpen={menuIsOpen}>
      <Select
        id={id}
        name={name}
        styles={styles}
        menuIsOpen={menuIsOpen}
        components={{ DropdownIndicator }}
        options={setOptionLabelFromNameOrValue(options)}
        value={{[FIELD_LABEL]: value, [FIELD_VALUE]: value }}
        onChange={values => action(values, fieldIndex, dataType, groupId)}
      />
    </OutsideClickHandler>
  );
});

export default FieldSelect;
